<template>
  <v-row class="px-2">
    <v-col class="py-0 pr-0">
      <v-text-field
        :value="formattedValue"
        v-bind="$attrs"
        v-on="$listeners"
        @input="input"
        @keypress="keypress"
        @focus="focus"
        @blur="blur"
      />
    </v-col>

    <v-col class="py-0 pl-0">
      <v-select
        v-model="currentUnitValue"
        :label="unitLabel"
        :disabled="$attrs.disabled"
        :items="units"
        item-text="label"
        item-value="value"
      />
    </v-col>
  </v-row>
</template>

<script>
import CurrencyInputMixin from '../../mixins/currency-input';

export default {
  mixins: [
    CurrencyInputMixin,
  ],

  props: {
    defaultUnit: String,
    unitValue: String,
    unitLabel: String,
    units: Array,
    precision: { type: Number, default: 0 },
    prefix: { type: String, default: '' },
    maxLength: { type: Number, default: Number.MAX_VALUE },
    onlyPositive: { type: Boolean, default: true },
  },

  data() {
    return {
      currentUnitValue: '',
    };
  },

  watch: {
    unitValue(newValue) {
      this.currentUnitValue = newValue;
    },

    currentUnitValue(newValue) {
      if (this.parse(this.formattedValue) !== 0) {
        this.$emit('update:unit-value', newValue);
      }
    },
  },

  mounted() {
    this.currentUnitValue = this.unitValue || this.defaultUnit;
  },

  methods: {
    findUnit(str) {
      const s = (str || '').toLowerCase();
      const k = `alias_${this.$i18n.locale}`;
      return _.find(this.units, u => u[k].toLowerCase() === s);
    },

    keypress(e) {
      const k = `alias_${this.$i18n.locale}`;
      const alphas = _.flatten(_.map(this.units, u => [u[k].toUpperCase(), u[k].toLowerCase()]));

      const keyCode = e.keyCode ? e.keyCode : e.which;
      if ((keyCode < 48 || keyCode > 57)) {
        e.preventDefault();
      }

      if (this.precision === 0 && keyCode === 46) {
        e.preventDefault();
      }

      if (this.formattedValue.toString().length >= this.maxLength) {
        e.preventDefault();
        return;
      }

      const c = String.fromCharCode(keyCode);
      if (_.includes(alphas, c)) {
        const { value } = this.findUnit(c);
        this.currentUnitValue = value;
        e.preventDefault();
      }

      if (!this.onlyPositive && keyCode === 45) {
        const { value } = this.parse(this.formattedValue);
        this.formattedValue = -value;
        this.$emit('input', -value);
      }
    },
  }
};
</script>
